/**
 * 파일 관련 핸들러 함수들
 */

/**
 * 파일 클릭 핸들러
 * @param {string} fileName - 클릭한 파일 이름
 * @param {number|null} fileStep - 파일이 속한 단계 (1 또는 2)
 * @param {object} params - 필요한 상태 및 함수들
 */
export const handleFileClick = (fileName, fileStep, params) => {
    const {
        step,
        selectedProblem,
        activeFileStep,
        fileClickCounterRef,
        activeFileNameRef,
        setActiveFileName,
        setActiveFileStep,
        setFileContents
    } = params;

    // fileStep이 전달되지 않으면 현재 step과 파일 목록을 기반으로 추론
    let targetStep = fileStep;
    if (!targetStep) {
        // 2단계일 때는 두 파일 목록 모두 확인
        if (step >= 2) {
            const isVul = selectedProblem.vulFiles?.some(f => f.fileName === fileName);
            const isSec = selectedProblem.secFiles?.some(f => f.fileName === fileName);
            if (isVul && isSec) {
                // 둘 다 있으면 현재 activeFileStep과 동일한 단계 유지하거나, 기본값은 2단계
                targetStep = activeFileStep === 1 ? 1 : 2;
            } else if (isVul) {
                targetStep = 1;
            } else if (isSec) {
                targetStep = 2;
            } else {
                targetStep = step === 1 ? 1 : 2;
            }
        } else {
            targetStep = 1;
        }
    }
    
    // 파일 클릭 횟수 증가 (같은 fileName이어도 상태 변경 보장)
    fileClickCounterRef.current += 1;
    activeFileNameRef.current = fileName;
    setActiveFileName(fileName);
    setActiveFileStep(targetStep);
    
    // 2단계에서 1단계 파일로 전환 시 fileContents에서 해당 파일 제거 (혹시 모를 오염 방지)
    if (targetStep === 1 && step >= 2) {
        setFileContents(prev => {
            const newContents = { ...prev };
            delete newContents[fileName];
            return newContents;
        });
    }
};

/**
 * 리셋 핸들러
 * @param {number} step - 리셋할 단계 (1 또는 2)
 * @param {object} params - 필요한 상태 및 함수들
 */
export const handleReset = (step, params) => {
    const {
        selectedProblem,
        setSelectedLines,
        setModifiedCode,
        setFileContents,
        setActiveFileName,
        setActiveFileStep,
        activeFileNameRef
    } = params;

    if (step === 1) {
        setSelectedLines([]);
        const firstVulFile = selectedProblem.vulFiles[0]?.fileName;
        setActiveFileName(firstVulFile);
        setActiveFileStep(1);
        activeFileNameRef.current = firstVulFile;
    } else if (step === 2) {
        setModifiedCode([]);
        setFileContents({}); // 수정된 파일 내용도 초기화
        // 2단계일 때는 2단계 파일 중 첫 번째 파일로 이동
        const firstSecFile = selectedProblem.secFiles?.[0]?.fileName || selectedProblem.vulFiles[0]?.fileName;
        const targetStep = selectedProblem.secFiles?.[0] ? 2 : 1;
        setActiveFileName(firstSecFile);
        setActiveFileStep(targetStep);
        activeFileNameRef.current = firstSecFile;
    }
};
